<template>
	<datatype-input
		:datatype="isArray ? arraytype : datatype"
		:is-array="isArray"
		:attribute-id="instanceAttributeId"
		:label="term"
		:autofocus="false"
		:instance-task="compProps.instanceTask"
		:show-unknown-button="compProps.showUnknownButton"
		style="width: 100%"
		@set="onSet"
	/>
</template>

<script setup lang="ts">
import { InstanceTask } from "@lr-notitia/notitia-operator/schemas";
import { PropType, computed } from "vue";
import { useGraphStore } from "../../../store/graph";
import { useSymbolsStore } from "../../../store/symbols";
import { useQuestionHistoryStore } from "../../../store/questionHistory";
import DatatypeInput from "./DatatypeInput.vue";

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();
const questionHistoryStore = useQuestionHistoryStore();

const emits = defineEmits(["set"]);
const compProps = defineProps({
	instanceAttributeId: {
		type: String,
		required: true,
	},
	instanceTask: {
		type: Object as PropType<InstanceTask>,
		required: true,
	},
	showUnknownButton: {
		type: String,
		required: true,
	},
});

const instanceAttribute = computed(() => {
	return graphStore.instance.attribute.byId(compProps.instanceAttributeId);
});

const datatype = computed(() => {
	let conceptAttribute = graphStore.concept.attribute.byId(instanceAttribute.value?.concept || "");
	return graphStore.descriptor.datatype.byId(conceptAttribute?.datatype || "");
});
const arraytype = computed(() => {
	if (datatype.value?.id !== "array") return;
	let conceptAttribute = graphStore.concept.attribute.byId(instanceAttribute.value?.concept || "");
	return graphStore.descriptor.datatype.byId(conceptAttribute?.arraytype || "");
});
const isArray = computed(() => datatype.value?.id === "array");
const term = computed(() => {
	let conceptAttribute = graphStore.concept.attribute.byId(instanceAttribute.value?.concept || "");
	return symbolsStore.term({
		id: conceptAttribute?.refersTo || "",
		terminology: conceptAttribute?.terminology,
	});
});

async function onSet(value: any) {
	emits("set");
	const attrId = instanceAttribute.value?.id || "";
	const previousValue = instanceAttribute.value?.value ?? "undefined";

	questionHistoryStore.push({
		type: "single",
		taskId: compProps.instanceTask.id,
		changes: [{ attrId, previousValue }],
	});

	if (value || value === 0) {
		await graphStore.instance.attribute.update(attrId, value);
	} else {
		await graphStore.instance.attribute.update(attrId, "undefined");
	}
	graphStore.instance.task.markAnsweredBy(compProps.instanceTask, [
		{ instanceAttrId: attrId, source: "web_ui", value },
	]);
}
</script>
